import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppToken } from '../../../models/app-token';
import { SectionService } from './section.service';
import { SectionStore } from './section.store';
import { SectionQuery } from './section.query';

@Injectable({ providedIn: 'root' })
export class SectionFacade extends BaseFacade {

  constructor(
    private readonly sectionService: SectionService,
    sectionStore: SectionStore,
    sectionQuery: SectionQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(sectionService,
      sectionStore,
      sectionQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade(AppToken.SECTION_SCHEMA_NAME),
      translateService,
      AppToken.SECTION_SCHEMA_NAME + '-facade'
      );
  }

}
